/**
 * Labstep
 *
 * @module
 * @desc Signin Screen
 */

import { withAuthenticatedUser } from 'labstep-web/containers/AuthenticatedUser';
import { withUiPersistent } from 'labstep-web/containers/UiPersistent';
import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { Columns } from 'labstep-web/screens/Authentication/Columns';
import { Right } from 'labstep-web/screens/Authentication/Signin/Right';
import { ShareLinkHeader } from 'labstep-web/screens/Authentication/Signin/ShareLinkHeader';
import type React from 'react';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { ISigninScreenContainerProps } from './types';

export const SigninScreenContainer: React.FC<
  ISigninScreenContainerProps
> = ({ right, authenticatedUser, uiPersistent }) => {
  const activeShareLink = uiPersistent.active_share_link;
  const isMfaScreen =
    authenticatedUser.mfa_required &&
    !authenticatedUser.authenticated;

  let header = 'Welcome back';
  let explainer = 'Sign into your account';
  if (isMfaScreen) {
    header = 'Two-factor Authentication';
    explainer = '';
  } else if (activeShareLink) {
    header = '';
    explainer = '';
  }

  return (
    <>
      <DocumentHead title="Signin" />
      <Columns
        header={header}
        explainer={explainer}
        left={
          <div className={styles.imageContainer}>
            <Image src="/img/landing/robot_main.svg" fluid />
          </div>
        }
        right={
          <div>
            {!isMfaScreen && activeShareLink && (
              <ShareLinkHeader
                sign="in"
                shareLink={activeShareLink}
              />
            )}
            {right || <Right isMfaScreen={isMfaScreen} />}
          </div>
        }
      />
    </>
  );
};

export default withUiPersistent(
  withAuthenticatedUser(SigninScreenContainer),
);
